import { FormGroup, NumericInput } from "@blueprintjs/core";
import { type AnimationOptionFade } from "@package/ui-gql/index-data-access";

type AnimationOptionFadeComponentProps = {
  disabled: boolean;
  option: AnimationOptionFade;
  onOptionUpdated: (option: AnimationOptionFade) => void;
};

export function AnimationOptionFadeComponent({
  disabled,
  option,
  onOptionUpdated,
}: AnimationOptionFadeComponentProps) {
  return (
    <FormGroup
      disabled={disabled}
      label="Fade Duration Seconds"
      fill
      helperText="Duration of the fade animation in seconds"
    >
      <NumericInput
        min={0}
        disabled={disabled}
        allowNumericCharactersOnly
        fill
        value={option.duration ?? 0}
        onValueChange={(duration) => {
          onOptionUpdated({
            ...option,
            duration,
          });
        }}
      />
    </FormGroup>
  );
}
